import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux'
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { orderBy } from "@progress/kendo-data-query";
import {PopUp} from '../../components/PopUp/PopUp.js'

import { ibanCheckAPI } from "../../../api/iban-check/ibanCheckAPI"
import LoadingOverlay from 'react-loading-overlay-ts';


function LogRequestGridContainer({dataGrid, from, to, userPreFilter, searchFilter}) {

  const initialSort = [
    {
      field: "row",
      dir: "asc",
    },
  ];

  //const initialGrid = {dataGrid};

  const voidRecord = [];
//  const [data, setData] = React.useState(voidRecord);
  const [values, setValues] = React.useState(voidRecord);
  const [sort, setSort] = React.useState(initialSort);
  //setData(dataGrid);
  const [isActive, setActive] = useState(false)

  const [show, setShow] = useState(false);

  const showModal = () => {
    setShow(true);
  }

  const hideModal = () => {
    setShow(false);
  }
  

  useEffect(() => {

    if(dataGrid !== undefined)
    {
      setValues(dataGrid)
    }

    // if(from !== undefined && to !== undefined && userPreFilter !== undefined){
    //   getReq(from, to, userPreFilter);

    //   const interval = setInterval(() => {
    //     getReq(from, to, userPreFilter);
    //    }, 1000*5);       
         
    //    return()=>clearInterval(interval)
    //}


  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dataGrid])
 
 

  // function handleShowModal(log) {
    
  //   if (log) setLog(log.replace(/\n/g, '<br>'));
    
  //   setShowModal(true);
  // }

  // function handleCloseModal() { 
  //   setShowModal(false);
  //   setLog("");
  // }

  // function handleDate(date) {
  //   var d = new Date(date);
  //         return d.getDate().toString().padStart(2, '0') + "-"
  //         + (d.getMonth()+1).toString().padStart(2, '0') + "-"
  //         + d.getFullYear() + " "
  //         + d.getHours().toString().padStart(2, '0') + ":"
  //         + d.getMinutes().toString().padStart(2, '0') + ":"
  //         + d.getSeconds().toString().padStart(2, '0');
  // }


  const initialDataState = {
    skip: 0,
    take: 6,
  };

  const [page, setPage] = React.useState(initialDataState);

  const pageChange = (event) => {
    setPage(event.page);
  };


  function setCheck(e){
    //e.preventDefault();
    //var a = this.state.values;
    var grid = {dataGrid};

    if (grid.dataGrid === undefined)
    {
      showModal();
    }
    else
    {
    
      //var arr = [{'ID' :  this.state.values.id, 'IBAN': this.state.values.iban, 'PIVA':this.state.values.piva }];
      var payload = {data: grid }  ;// nominationList;
      setActive(value => !value);

      var code = window.sessionStorage.getItem('code');
      ibanCheckAPI.getIbanArrayCheck(dataGrid, code, (res) => {
        if (!res || res.length === 0) {
        setValues(this.state.values);
        setActive(value => !value);
      }
        else {
          setValues(res);
          setActive(value => !value);
          //var values = this.state.values;
          //values.esito = res[0].esito;
          //values.isValid = res[0].isvalid;
          //this.setState({ values: values });
        }
      })
    }
    
  
  }


  
  // const { classes } = this.props
  return (
    <>

 <LoadingOverlay
      active={isActive}
      spinner
      text='Loading ...'
    >
      <PopUp show={show} handleClose={hideModal}>
          <div className="row" style={{height: "30px", marginLeft:"0px", marginRight:"0px", backgroundColor: "#FDA443", borderRadius:"10px 10px 0px 0px"}}> </div>
          <p></p>
          <h2 className="row justify-content-md-center"> Attenzione: Nessun file Excel caricato!</h2>
        </PopUp>
      <Grid
              style={{
                height: "400px",
              }}
              //data={dataGrid}
              //data={values}
              data={orderBy(values, sort)}
              skip={page.skip}
              take={page.take}
              total={0}              
              pageable={false}
              pageSize={25}
              onPageChange={pageChange}
              resizable={true}
              sortable={true}
              sort={sort}
              onSortChange={(e) => {
                setSort(e.sort);
              }}
            >
           {/*    <Column field="insertDate" title="Data" 
              cell={(props) => (
                <td>                  
                   {
                     handleDate(props.dataItem.insertDate)                     
                  }                 
                </td>
              )}
              /> */}
              <Column field="row" title="N° Riga" width="70"/>
              <Column field="iban" title="IBAN" width="230"/>
              <Column field="piva" title="P.IVA" width="150" />
              <Column field="cf" title="Codice Fiscale" width="150" />
              <Column field="isvalid" title="Validazione Excel" width="280"
              cell ={(props) => {
                const rowValid = props.dataItem.isvalid.length > 0;
                const field = props.field || "";
                const style = {
                  backgroundColor: rowValid
                    ? "rgb(243, 23, 0, 0.32)"
                    : "rgb(55, 180, 0, 0.32)",
                };

                return(
                <td style={style}>{props.dataItem[field]}</td>
                
              )}} />
              <Column field="isvalidbintesa" title="Esito Check Banca Intesa" width="160" 
              cell ={(props) => {
                const rowValid = props.dataItem.isvalidbintesa==="OK";
                const cellEmpty = props.dataItem.isvalidbintesa && props.dataItem.isvalidbintesa.length === 0;
                const cellValue = props.dataItem.isvalidbintesa;
                const field = props.field || "";
                const style = {
                  backgroundColor: rowValid
                    ? "rgb(55, 180, 0, 0.32)"
                    : "rgb(243, 23, 0, 0.32)",
                };


                if(cellValue !== "OK" && cellValue !== "KO") //cellEmpty == "") 
                {
                  return(
                    <td>{props.dataItem[field]}</td>)  
                }
                return(
                  <td style={style}>{props.dataItem[field]}</td>)
              }}/>
              <Column field="esito" title="Info Aggiuntive" width="250" />
            </Grid>
            </LoadingOverlay>
            <br/>
           <input type="submit" value="Verifica" onClick={e => setCheck(e.target.value)} style={{backgroundColor:"#187DE4!important", borderColor: "#187DE4!important"}}/>
    </>
  );
}

export const LogRequestGrid = connect(null, null)(LogRequestGridContainer)